var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c(_setup.BButton,{staticClass:"m-1",attrs:{"id":"page-create"},on:{"click":_setup.create}},[_c(_setup.FontAwesomeIcon,{attrs:{"icon":"plus"}}),_vm._v("\n        "+_vm._s(_vm._f("localize")("Create"))+"\n    ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }